/* eslint-disable indent */
import { Col, Row } from 'antd';
import React from 'react';
import './CardPeopleDensity.scss';
import { BaseCard } from '../BaseCard';
import { IconPeopleDensity, IconPeopleDensityDashboard } from '@bvt-icons';
import _ from 'lodash';

/**
 * @author Renta <renta.yustika@bvarta.com>
 * @author Randa <m.randa@bvarta.com>
 * @param {object} props
 * @param {string} props.className
 * @param {import('react').CSSProperties} props.style
 * @param {object} props.detailInfo
 * @param {string} props.detailInfo.catchmentBy
 * @param {number} props.detailInfo.year
 * @param {number} props.detailInfo.month
 * @param {number} props.detailInfo.date
 * @param {object} props.detailInfo.time
 * @param {number} props.detailInfo.time.min
 * @param {number} props.detailInfo.time.max
 * @param {string} props.detailInfo.timeType
 * @param {boolean} props.isLoading
 * @param {boolean} props.showDetail
 * @param {number} props.value
 * @param {string} props.type
 */

export const CardPeopleDensity = (props) => {
  const { isLoading, showDetail, value, detailInfo, style, className, type } = props;

  const numberWithDots = (num) => {
    return num?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  };

  const getMonthName = (month) => {
    const months = [
      '',
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    return months[month];
  };

  const formattingTime = (time) => {
    const amPm = time >= 12 ? 'PM' : 'AM';
    const format12 = (time % 12 || 12) < 10 ? '0' : '';
    return !isNaN(time)
      ? `${format12}${(time % 12 || 12)}:00 ${amPm}`
      : undefined;
  };

  const renderTime = () => {
    return typeof detailInfo?.time?.min === 'number' &&
      typeof detailInfo?.time?.max === 'number'
      ? `${formattingTime(detailInfo?.time?.min) || '-'} - ${
          formattingTime(detailInfo?.time?.max) || '-'
        }`
      : '-';
  };

  const catchmentText = () => {
    return type === 'site_profiling' ? 'Calculation by catchment per' : 'Calculation by grid per';
  };

  return (
    <div className={`card-people-density ${className}`} style={style}>
      <BaseCard isLoading={isLoading} title='People density' withPadding={true}>
        <Row align='middle'>
          {!showDetail ? (
            <Col className='card-people-density__col' xs={24}>
              <IconPeopleDensity
                title={`${_.capitalize(detailInfo?.catchmentBy)} Devices`}
                value={numberWithDots(value)}
              />
            </Col>
          ) : (
            <div className='card-people-density__wrapper'>
              <Col className='card-people-density__col' sm={12} xs={24}>
                <IconPeopleDensityDashboard
                  title={`${_.capitalize(detailInfo?.catchmentBy)} Devices`}
                  value={numberWithDots(value)}
                />
              </Col>
              <Col className='card-people-density__col' sm={12} xs={24}>
                <div className='card-people-density__detail'>
                  <div className='card-people-density__row'>
                    <span className='title'>{catchmentText()}</span>
                    <span className='value'>
                      {detailInfo?.catchmentBy || '-'}
                    </span>
                  </div>
                  <div className='card-people-density__row'>
                    <span className='title'>Year</span>
                    <span className='value'>{detailInfo?.year || '-'}</span>
                  </div>
                  <div className='card-people-density__row'>
                    <span className='title'>Month</span>
                    <span className='value'>
                      {getMonthName(detailInfo?.month) || '-'}
                    </span>
                  </div>
                  <div className='card-people-density__row'>
                    <span className='title'>Date</span>
                    <span className='value'>{detailInfo?.catchmentBy?.toLocaleUpperCase() !== 'AVERAGE' ? detailInfo?.date : '-'}</span>
                  </div>
                  <div className='card-people-density__row'>
                    <span className='title'>Time type</span>
                    <span className='value'>{detailInfo?.catchmentBy?.toLocaleUpperCase() !== 'AVERAGE' ? detailInfo?.timeType : '-'}</span>
                  </div>
                  <div className='card-people-density__row'>
                    <span className='title'>Time</span>
                    <span className='value'>{detailInfo?.catchmentBy?.toLocaleUpperCase() !== 'AVERAGE' ? renderTime() : '-'}</span>
                  </div>
                </div>
              </Col>
            </div>
          )}
        </Row>
      </BaseCard>
    </div>
  );
};
